import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Analytics_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.733 13.083a11.671 11.671 0 0 1 11.6-10.416v11.666H2.667c0-.422.022-.839.066-1.25Zm1.258 0a10.422 10.422 0 0 1 9.092-9.092v9.092H3.991Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.708a.625.625 0 1 0 0 1.25c6.098 0 11.042 4.944 11.042 11.042S22.098 27.042 16 27.042 4.958 22.098 4.958 16a.625.625 0 1 0-1.25 0c0 6.789 5.503 12.292 12.292 12.292 6.788 0 12.292-5.503 12.292-12.292 0-6.788-5.504-12.292-12.292-12.292Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Analytics_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.667 2.667)",
    d: "M0 0h26.667v26.667H0z"
  }))));
};

var SvgAnalytics = styled(SvgComponent).withConfig({
  displayName: "Analytics__SvgAnalytics",
  componentId: "sc-t9lrby-0"
})(["", " ", ""], size, color);
export default SvgAnalytics;